/**
 * product-measurements.js
 * Tab Product measurements di Station Tabs: konten dari snippet (dropdown variant + angka metafield variant).
 * Tab cuma tampil kalau ada gambar template (product metafield); angka (chest, length, sleeve, bottom) dari variant metafield.
 * Alur: whenReady → whenPageLoaded → run → injectTab (atau showMeasurementsInPlace kalo tabset ga ada).
 */
(function () {
  const TAB_ID = 'station-tabs-tab_measurements';
  const PANEL_ID = 'station-tabs-tabpanel_measurements';
  const TAB_SLUG = 'product-measurements';
  const PANEL_CLOSE_ANIMATION_MS = 420;

  // cari container tab (Details, Size Guide, dll) — buat tau mau inject ke sini atau tampil in-place
  function findTabset() {
    return document.querySelector('.station-tabs-tabset');
  }

  // cek tab kita udah ke-inject belum, biar ga dobel
  function alreadyInjected() {
    return document.getElementById(TAB_ID) !== null;
  }

  /**
   * Cari div sumber konten measurements (render dari Liquid, awalnya display:none).
   * Ga return kalau di dalamnya sudah ada .station-tabs-tabcontent (artinya sudah dipindah).
   * @returns {Element|null} .product-measurements-source atau null
   */
  function findMeasurementsSource() {
    const source = document.querySelector('.product-measurements-source');
    if (!source) return null;
    if (source.querySelector('.station-tabs-tabcontent')) return null;
    return source;
  }

  // source yang beneran ada isinya (buat createTabPanel / getTabLabel)
  function findMeasurementsContent() {
    const source = findMeasurementsSource();
    if (!source || !source.firstChild) return null;
    return source;
  }

  // Hanya tampilkan tab kalau ada gambar template (product metafield); kalau ga ada gambar jangan tampilin
  function hasTemplateMeasurementImage(sourceEl) {
    if (!sourceEl) return false;
    return sourceEl.querySelector('.size-guide-item img[src]') !== null;
  }

  /**
   * Ambil label untuk tab (teks yang keliatan di tab).
   * Bisa dari data-tab-title di .product-measurements-block, default "Product measurements".
   * @param {Element} sourceEl - element source (punya .size-guide-wrapper / .product-measurements-block)
   * @returns {string} label untuk tab
   */
  function getTabLabel(sourceEl) {
    if (!sourceEl) return 'Product measurements';
    const wrapper = sourceEl.querySelector('.size-guide-wrapper');
    const block = wrapper && wrapper.closest('.product-measurements-block');
    return (block && block.getAttribute('data-tab-title')) || 'Product measurements';
  }

  // bikin elemen tab (yang diklik) — h4 + span, class/aria disesuain sama Station Tabs
  function createTabTitle(tabLabel) {
    const h4 = document.createElement('h4');
    h4.className = 'station-tabs-tabtitle';
    const span = document.createElement('span');
    span.id = TAB_ID;
    span.className = 'station-tabs-tab mod-last';
    span.setAttribute('aria-controls', PANEL_ID);
    span.setAttribute('data-slug', TAB_SLUG);
    span.setAttribute('tabindex', '-1');
    span.setAttribute('role', 'tab');
    span.setAttribute('aria-selected', 'false');
    const labelEl = document.createElement('span');
    labelEl.className = 'station-tabs-tabtext';
    labelEl.textContent = tabLabel;
    span.appendChild(labelEl);
    h4.appendChild(span);
    return h4;
  }

  // bikin panel isi tab; isi source dipindah (bukan clone) ke sini — source jadi kosong
  function createTabPanel(sourceEl) {
    const panel = document.createElement('div');
    panel.className = 'station-tabs-tabpanel';
    panel.id = PANEL_ID;
    panel.setAttribute('aria-labelledby', TAB_ID);
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('role', 'tabpanel');
    const tabcontent = document.createElement('div');
    tabcontent.className = 'station-tabs-tabcontent';
    if (sourceEl) {
      while (sourceEl.firstChild) {
        tabcontent.appendChild(sourceEl.firstChild);
      }
    }
    panel.appendChild(tabcontent);
    return panel;
  }

  /**
   * Hapus class mod-last dari tab lain (supaya cuma tab kita yang punya mod-last).
   * Dipanggil sebelum append tab baru, biar styling "tab terakhir" konsisten.
   * @param {Element} tabset - .station-tabs-tabset
   */
  function removeModLastFromPreviousTab(tabset) {
    const lastTabs = tabset.querySelectorAll('.station-tabs-tab.mod-last');
    lastTabs.forEach(function (tab) {
      if (tab.id !== TAB_ID) {
        tab.classList.remove('mod-last');
      }
    });
  }

  // update aria-owns di tablist biar screen reader tau tab kita bagian dari sini
  function updateTablistAriaOwns(tabset, newTabId) {
    const tablist = tabset.querySelector('.station-tabs-tablist[role="tablist"]');
    if (!tablist) return;
    const current = tablist.getAttribute('aria-owns') || '';
    const ids = current ? current.trim().split(/\s+/) : [];
    if (ids.indexOf(newTabId) === -1) {
      ids.push(newTabId);
      tablist.setAttribute('aria-owns', ids.join(' '));
    }
  }

  // aktifin tab yang diklik (is-active, panel tampil), yang lain dimatiin
  function activateTab(tabEl, tabset) {
    const panelId = tabEl.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel || !tabset.contains(panel)) return;

    const allTabs = tabset.querySelectorAll('.station-tabs-tab');
    const allPanels = tabset.querySelectorAll('.station-tabs-tabpanel');

    allTabs.forEach(function (t) {
      t.classList.remove('is-active');
      if (t.id === tabEl.id) t.classList.add('is-active');
      t.setAttribute('aria-selected', t.id === tabEl.id ? 'true' : 'false');
      t.setAttribute('tabindex', t.id === tabEl.id ? '0' : '-1');
    });
    allPanels.forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-hidden', p.id === panelId ? 'false' : 'true');
      if (p.id === panelId) {
        p.classList.add('is-active');
        if (isMobileView() && p.id === PANEL_ID) {
          if (p._closeTimer) clearTimeout(p._closeTimer);
          p.style.removeProperty('display');
          p.style.removeProperty('overflow');
          p.style.removeProperty('max-height');
          p.style.removeProperty('opacity');
          p.style.removeProperty('transform');
          p.style.removeProperty('transition');
        }
      }
    });
  }

      // tutup tab aktif (khusus toggle di mobile saat diklik lagi)
  function deactivateTab(tabEl, tabset) {
    const panelId = tabEl.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel || !tabset.contains(panel)) return;

    tabEl.classList.remove('is-active');
    tabEl.setAttribute('aria-selected', 'false');
    tabEl.setAttribute('tabindex', '-1');

    // khusus panel measurements di mobile: collapse pakai JS dulu, baru remove class + hide
    if (isMobileView() && panel.id === PANEL_ID) {
      const startHeight = panel.scrollHeight;
      panel.style.display = 'block';
      panel.style.overflow = 'hidden';
      panel.style.maxHeight = startHeight + 'px';
      panel.style.opacity = '1';
      panel.style.transform = 'translateY(0)';
      panel.style.transition = 'max-height 0.4s ease, opacity 0.3s ease, transform 0.3s ease';

      // force reflow supaya browser nangkep start state sebelum ke end state
      panel.offsetHeight;

      panel.style.maxHeight = '0px';
      panel.style.opacity = '0';
      panel.style.transform = 'translateY(-8px)';
      panel.setAttribute('aria-hidden', 'false');
      if (panel._closeTimer) clearTimeout(panel._closeTimer);
      panel._closeTimer = setTimeout(function () {
        if (!tabEl.classList.contains('is-active')) {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-hidden', 'true');
          panel.style.removeProperty('display');
          panel.style.removeProperty('overflow');
          panel.style.removeProperty('max-height');
          panel.style.removeProperty('opacity');
          panel.style.removeProperty('transform');
          panel.style.removeProperty('transition');
        }
      }, PANEL_CLOSE_ANIMATION_MS);
      return;
    }

    panel.classList.remove('is-active');
    panel.setAttribute('aria-hidden', 'true');
  }

  // deteksi viewport mobile buat behavior toggle tab
  function isMobileView() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function normalizeSizeValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function sortVariantSelectBySize(selectEl) {
    if (!selectEl || !selectEl.options || selectEl.options.length < 2) return;

    const order = [
      'xs', 's', 'm', 's/m', 'l', 'xl', 'l/xl', 'xxl', 'xxxl', 'xxl/xxxl', 'xxxxl',
      '2xl', '3xl', '1-2 year', '1-2year', '3-4 year', '3-4year', '5-6 year',
      '5-6year', '7-8 year', '7-8year', '9- 10 year', '9-10 year', '9-10year',
      '11-12 year', '11-12year', '11-12 years'
    ].map(normalizeSizeValue);
    const rankBySize = {};
    order.forEach(function (size, index) {
      if (rankBySize[size] === undefined) rankBySize[size] = index;
    });

    const selectedValue = selectEl.value;
    const options = Array.prototype.slice.call(selectEl.options);
    options.sort(function (a, b) {
      const aSize = normalizeSizeValue(a.textContent || a.innerText);
      const bSize = normalizeSizeValue(b.textContent || b.innerText);
      const aRank = rankBySize[aSize];
      const bRank = rankBySize[bSize];
      const aKnown = aRank !== undefined;
      const bKnown = bRank !== undefined;

      if (aKnown && bKnown) return aRank - bRank;
      if (aKnown) return -1;
      if (bKnown) return 1;
      return a.textContent.localeCompare(b.textContent, undefined, { sensitivity: 'base' });
    });

    options.forEach(function (option) {
      selectEl.appendChild(option);
    });

    if (selectedValue) {
      selectEl.value = selectedValue;
    }
  }

  // binding dropdown / tombol variant — ganti pilihan → show/hide .size-guide-item yang cocok
  function bindVariantSummary() {
    const panel = document.getElementById(PANEL_ID);
    if (!panel) return;
    const items = panel.querySelectorAll('.size-guide-item');
    if (!items.length) return;

    const buttons = panel.querySelectorAll('.size-guide-variant-btn');
    const select = panel.querySelector('.size-guide-variant-select');
    const currentText = panel.querySelector('.size-guide-variant-current');

    function showVariant(variantId) {
      const id = String(variantId);
      items.forEach(function (item) {
        if (item.getAttribute('data-variant-id') === id) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-variant-id') === id ? 'true' : 'false');
      });
      if (select && select.value !== id) select.value = id;
      if (select && currentText) {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption) currentText.textContent = selectedOption.text;
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showVariant(btn.getAttribute('data-variant-id'));
      });
    });

    if (select) {
      sortVariantSelectBySize(select);
      select.addEventListener('change', function () {
        showVariant(select.value);
      });
      showVariant(select.value);
    }
  }

  // binding klik & keyboard di tab — klik/Enter/Space → activateTab
  function bindTabLogic(tabset) {
    tabset.addEventListener('click', function (e) {
      const tab = e.target.closest('.station-tabs-tab');
      if (!tab || !tabset.contains(tab)) return;
      if (isMobileView() && tab.id === TAB_ID && tab.classList.contains('is-active')) {
        deactivateTab(tab, tabset);
        return;
      }
      activateTab(tab, tabset);
    });
    tabset.addEventListener('keydown', function (e) {
      const tab = e.target.closest('.station-tabs-tab');
      if (!tab || !tabset.contains(tab)) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (isMobileView() && tab.id === TAB_ID && tab.classList.contains('is-active')) {
          deactivateTab(tab, tabset);
          return;
        }
        activateTab(tab, tabset);
      }
    });
  }

  // Bungkus tiap pasangan heading (.body2_semibold) + deskripsi (.font_xs_regular) jadi satu div
  function wrapDescriptionItems(rootEl) {
    if (!rootEl) return;
    var container = rootEl.querySelector('.Deskripsi-product-measurements-item-desc.rte');
    if (!container) return;

    var headings = container.querySelectorAll('.body2_semibold');
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var desc = heading.nextElementSibling;
      if (!desc || !desc.classList.contains('font_xs_regular')) continue;

      var wrap = document.createElement('div');
      wrap.className = 'product-measurements-desc-item';
      container.insertBefore(wrap, heading);
      wrap.appendChild(heading);
      wrap.appendChild(desc);
    }
  }

  // utama: cari tabset & source → bikin tab + panel → append → bind (ga nunggu gambar biar tab cepet tampil)
  function injectTab() {
    if (alreadyInjected()) return;

    const tabset = findTabset();
    if (!tabset) return;

    const source = findMeasurementsContent();
    if (!source) return;
    if (!hasTemplateMeasurementImage(source)) return;

    const tabLabel = getTabLabel(source);
    removeModLastFromPreviousTab(tabset);
    updateTablistAriaOwns(tabset, TAB_ID);

    const tabTitle = createTabTitle(tabLabel);
    const tabPanel = createTabPanel(source);
    tabset.appendChild(tabTitle);
    tabset.appendChild(tabPanel);
    bindTabLogic(tabset);
    bindVariantSummary();
    wrapDescriptionItems(tabPanel);
  }

  // fallback kalo tabset ga ketemu: tampilin source di tempat asal biar ga ilang
  function showMeasurementsInPlace() {
    const source = document.querySelector('.product-measurements-source');
    if (!source || !source.firstChild) return;
    if (!hasTemplateMeasurementImage(source)) return;
    source.style.display = '';
    source.removeAttribute('aria-hidden');
    wrapDescriptionItems(source);
  }

  function run() {
    if (findTabset()) {
      injectTab();
      return;
    }
    let attempts = 0;
    const maxAttempts = 80;
    const interval = setInterval(function () {
      attempts++;
      if (findTabset()) {
        clearInterval(interval);
        injectTab();
        return;
      }
      if (attempts >= maxAttempts) {
        clearInterval(interval);
        showMeasurementsInPlace();
      }
    }, 250);
  }

  // tunggu DOM ready trus lanjut whenPageLoaded
  function whenReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenPageLoaded);
    } else {
      whenPageLoaded();
    }
  }

  // jalanin run() pas page full load biar konten Liquid (termasuk img) udah ada
  function whenPageLoaded() {
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run);
    }
  }

  whenReady();
})();
